import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import MUIDataTable from "mui-datatables";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import { API_URL } from "../../config";
import { connect } from "react-redux";
import { pathSpliter } from "../../lib/functions";
import {
  currentRouteSet,
  createdCustomerSet,
  updatedCustomerSet,
  disableRestoreCustomerSet,
} from "../../actions/actions";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  pageEntryLabel: {
    color: "#7754cc",
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
}));

const ContactPersonsPerformance = ({ location, currentRouteSet, authInfo }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const fetchProductData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/api/get-old-stock`, null, {
        headers: { "auth-token": authInfo.token },
      });

      if (response.data.error) {
        setErrorMsg("Error fetching data");
      } else {
        setData(response.data.message);
        setSuccessMsg("Data fetched successfully!");
        console.log("23.01.2025 Data: ", response.data.message);
      }
    } catch (error) {
      setErrorMsg("Failed to fetch data from the server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    fetchProductData();
  }, []);

  const columns = [
    { name: "prod_id", label: "Product Id" },
    { name: "prod_name", label: "Product Name" },
    { name: "current_stock", label: "Quantity" },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    responsive: "standard",
  };
  console.log(" Rackwise Data: ", data);
  return (
    <div className={classes.root}>
      {successMsg && (
        <Snackbar
          open={!!successMsg}
          autoHideDuration={6000}
          onClose={() => setSuccessMsg("")}
        >
          <Alert onClose={() => setSuccessMsg("")} severity="success">
            {successMsg}
          </Alert>
        </Snackbar>
      )}

      {errorMsg && (
        <Snackbar
          open={!!errorMsg}
          autoHideDuration={6000}
          onClose={() => setErrorMsg("")}
        >
          <Alert onClose={() => setErrorMsg("")} severity="error">
            {errorMsg}
          </Alert>
        </Snackbar>
      )}

      {/* <h2 className={classes.pageEntryLabel}>Product Rackwise Quantity</h2> */}

      {loading ? (
        <CircularProgress />
      ) : (
        <MUIDataTable
          title={"Old Stock ( 2 Year )"}
          data={data}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  authInfo: state.authInfoReducer,
});

export default connect(mapStateToProps, {
  currentRouteSet,
})(ContactPersonsPerformance);
